import { useNavigate } from "react-router-dom";

import { useEffect, useState } from "react";

import { useCheckIfAlreadyAcceptedMutation } from "@/pages/Private/redux/course-progress/course-progress.api";

import { LoadingOverlay } from "@/components";

import FirstNameLastNameForm from "./components/FistNameLastNameForm";
import OtpForm from "./components/OtpForm";

export default function ScenarioJoining() {
	const [token, setToken] = useState<string | null>(null);
	const [courseProgressId, setCourseProgressId] = useState<string | null>(null);

	const [checkIfAlreadyAccepted, { isLoading }] = useCheckIfAlreadyAcceptedMutation();
	const navigate = useNavigate();
	const [showFirstLastNameFields, setShowFirstLastNameFields] = useState(false);

	useEffect(() => {
		async function check() {
			if (token && courseProgressId) {
				const result = await checkIfAlreadyAccepted({
					accessToken: token,
					courseProgressId: courseProgressId,
				}).unwrap();

				if (result.courseProgressId) {
					navigate(`/app/scenarios/${result.courseProgressId}/progress`);
				}
			}
		}

		if (token && courseProgressId) {
			setShowFirstLastNameFields(true);
		}

		check();
	}, [token, courseProgressId, checkIfAlreadyAccepted, navigate]);

	return (
		<div className="w-full h-full flex items-center justify-center">
			{isLoading ? (
				<LoadingOverlay />
			) : (
				<>
					{showFirstLastNameFields && (
						<FirstNameLastNameForm courseProgressId={courseProgressId} token={token} />
					)}
					{!showFirstLastNameFields && (
						<OtpForm
							setCourseProgressId={setCourseProgressId}
							setShowFirstLastNameFields={setShowFirstLastNameFields}
							setToken={setToken}
						/>
					)}
				</>
			)}
		</div>
	);
}
